module.exports = __webpack_public_path__ + "static/media/logo512@2x.3a645a91.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo512@2x.png
// module id = 1239
// module chunks = 0